import {
  Module, ActionTree, MutationTree, GetterTree
} from 'vuex';
import { readCookie, writeCookie } from '@/tools/tools';
import { getUserInfo } from '@/services/http';
import { UserState } from './types';
import { RootState } from '../types';
/**
 * getters
 */
// export const getters: GetterTree<UserState, RootState> = {
//   addresslist: (state: UserState) => state.userinfolist,
// };

/**
 * mutations
 */
export const mutations: MutationTree<UserState> = {
  // 收货列表
  USERINFORLIST(state: UserState, payload: []) {
    state.userinfolist = payload;
    writeCookie('userinfolist', state.userinfolist);
  }
};

/**
 * actions
 */
export const actions: ActionTree<UserState, RootState> = {
  async setUserInfoList({ commit }) {
    const res: any = await getUserInfo({
      companyId: 1
    });
    commit('USERINFORLIST', res.data.data);
  }
};
/**
 * state
 */
export const state: UserState = {
  userinfolist: readCookie('userinfolist') ? readCookie('userinfolist') : []
};
const namespaced: boolean = true;

export const user: Module<UserState, RootState> = {
  namespaced,
  state,
  mutations,
  actions
};
